import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
// import 'swiper/css/navigation'
// import 'swiper/css/bundle'

import './scss/style.scss'

import bannerSlider from './js/banner-slider'
import HamburgerMenu from './js/hamburger-menu'
import Accordion from './js/accordion'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import FloatingBox from './js/floating-box'
import Opening from './js/opening'
import AccordionOffset from './js/accordion-offet'
import heroSlider from './js/hero-slider'

gsap.registerPlugin(ScrollTrigger)

gsap.defaults({
  ease: 'quint.out',
  duration: 0.8,
})

gsap.config({
  nullTargetWarn: false,
})

ScrollTrigger.defaults({
  start: 'top 75%',
})

// new Opening()
heroSlider()

new HamburgerMenu()

bannerSlider()

// const parallaxAnimation = () => {
//   const targets = document.getElementsByClassName('js-parallax')
//   ;[...targets].forEach((target) => new Parallax(target))
// }

// parallaxAnimation()

new FloatingBox()

const accordionEls = document.querySelectorAll('.js-accordion')
accordionEls?.forEach((el) => {
  new Accordion(el)
})

const accordionOffsetEls = document.querySelectorAll('.js-accordion-offset')
accordionOffsetEls.forEach((target) => {
  new AccordionOffset(target)
})
